<template>
  <div class="mt-12 mx-2 caption subtleColor">
    Synonyms on this page: {{ aliases.join(", ").toLowerCase() }}
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "IcdAliasList",
  props: {
    aliases: null,
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.subtleColor {
  color: #b1b1b1;
}
</style>
